// Older builds registered a cache-first service worker (sw-precache). It served the cached
// index.html and bundle on every navigation, so returning visitors saw each deploy one visit
// late, and new routes (for example /MagicLogin/<token>) did not exist on the first click.
//
// The site no longer registers a worker. public/service-worker.js is now a kill switch that
// clears the old caches and unregisters itself; unregisterAll() does the same from the page
// once the new bundle is running.

export function unregisterAll(nav = typeof navigator !== 'undefined' ? navigator : undefined,
                              cacheStorage = typeof caches !== 'undefined' ? caches : undefined) {
  const tasks = [];

  if (nav && nav.serviceWorker && typeof nav.serviceWorker.getRegistrations === 'function') {
    tasks.push(
      nav.serviceWorker
        .getRegistrations()
        .then(registrations => Promise.all(registrations.map(registration => registration.unregister())))
    );
  }

  if (cacheStorage && typeof cacheStorage.keys === 'function') {
    tasks.push(
      cacheStorage
        .keys()
        .then(keys => Promise.all(keys.map(key => cacheStorage.delete(key))))
    );
  }

  return Promise.all(tasks).then(() => undefined, () => undefined);
}

export default unregisterAll;



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js